var render = function render(){var _vm=this,_c=_vm._self._c;return _c('KTable',{attrs:{"headers":_vm.headers,"rows":_vm.rows,"caption":"User name, age and city","sortable":""}})
}
var staticRenderFns = []

export { render, staticRenderFns }